var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWalking = function SvgWalking(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.4 364.7C393 357.8 409.4 349.4 420.4 343C443.3 329.7 464.6 317.3 474 293C474.9 290.6 485 264.7 475.1 256C463.2 245.6 424.5 261.4 402.2 287.1C391.4 299.5 390.4 307.4 375.2 323.6C363.2 336.3 351.4 344.7 343.5 349.7L371.4 364.7Z",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.8 362.5C319.3 372.3 293.5 383.4 295.4 391.4C296.8 397.3 311.3 398.4 315.8 398.7C341.2 400.7 361.6 386.4 370.8 378.8C360 373 351.6 368.4 340.8 362.5Z",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M477.2 258.4C475.4 256.1 472.3 252.7 467.6 250C449.3 239.5 424.8 250.1 410.4 256.3C386.4 266.7 388.2 273 373.6 275.2C351.7 278.4 339.2 265.4 330.9 273C323.9 279.4 328.5 292.6 316.4 303.2C315 304.5 313.8 305.3 312.6 306C302.4 312.9 292 314.3 285.6 314.5C283.6 323.3 281.7 335.8 282.8 350.6C284.1 368.7 289.1 383 293.2 392.1",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.3 268.8C335.3 268.8 349.8 255.9 347.6 250.3C345.4 244.6 332.8 253.1 311.5 267C290.1 280.8 282.6 296.2 282.6 296.2L240.9 178.6",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.9 146L347.6 250.3",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M286.5 289.9L293.2 313.6",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M341.7 355L370.8 371.3",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.4 327.2C105 326.1 136.4 305.8 163.4 320.3C171 324.4 176.2 330.1 179.7 335.2C179.8 340.9 179.8 346.6 179.9 352.3C172.9 352.2 165.8 352.2 158.5 352.3C135.8 352.7 114.4 354.1 94.2 356.4C88.8 348 83 337.5 78 324.8C71.8 309.1 68.6 294.9 66.9 283.5L39.4 262.3C42.1 247.2 46.6 235.8 50.2 228.4C54.8 218.8 58.6 214.3 60 212.7C66.7 205 74 200.7 78.9 198.3C74.9 204.3 75 211.5 78.4 215.2C82.8 220 93.7 219.8 100 211.4C105.5 208.7 114.3 205.6 124.5 207.2C133 208.6 139.2 212.7 146.9 217.9C152.8 221.9 157.2 225.8 160.2 228.7C158.7 238.7 157.7 251.2 158.8 265.4C160.3 285.6 162.1 303.5 165.4 318.1",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9 244L66.9 283.5",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.3 211.7C182.1 212.6 181.7 213.4 181.2 214.2C175.1 224 150.9 220 127.1 205.3C103.4 190.6 89 170.8 95.1 161",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9 198.4L93 176.8",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1 161L126.9 83.1001",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.3 219.2L205 162.7",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWalking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/walking.svg";